"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiteWindow = void 0;
var Element_js_1 = require("./Element.js");
var Document_js_1 = require("./Document.js");
var List_js_1 = require("./List.js");
var Parser_js_1 = require("./Parser.js");
var LiteWindow = (function () {
    function LiteWindow() {
        this.DOMParser = Parser_js_1.LiteParser;
        this.NodeList = List_js_1.LiteList;
        this.HTMLCollection = List_js_1.LiteList;
        this.HTMLElement = Element_js_1.LiteElement;
        this.DocumentFragment = List_js_1.LiteList;
        this.Document = Document_js_1.LiteDocument;
        this.document = new Document_js_1.LiteDocument();
    }
    return LiteWindow;
}());
exports.LiteWindow = LiteWindow;
//# sourceMappingURL=Window.js.map